import { AALocationModel } from '../../route-planner/models/route-model';
import { TrafficNewsOption } from '../../traffic-news/models/traffic-news-model';
import { TrafficAlertType } from '../../google-map/enums/google-map-enum';

export class MapsHotelsModel {
    locationModel: AALocationModel;
    mapsOptionsData: Array<TrafficNewsOption> = [];

    constructor() {
        this.locationModel = new AALocationModel('');
        this.mapsOptionsData.push(
            new TrafficNewsOption(TrafficAlertType.HOTELS_AND_B_B, 'Hotels and B&Bs', './assets/icons/svg/icon-hotel.svg'),
            new TrafficNewsOption(TrafficAlertType.RESTAURANTS, 'Restaurants', './assets/icons/svg/icon-restaurant.svg'),
           // new TrafficNewsOption(TrafficAlertType.CAR_PARKS, 'Car parks', './assets/icons/svg/icon-car-park.svg'),
        );
    }
}

export enum TRAVEL_TYPE {
    PUB = 'PUB',
    GAC = 'GAC',
    RES = 'RES',
    BUD = 'BUD',
    HOT = 'HOT',
    SS  = 'SS',
}
